import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';

type ProgressBarMode = 'determinate' | 'indeterminate';

enum ProgressBarColor {
  Red = 'red',
  Orange = 'orange',
  Green = 'green',
}

@Component({
  selector: 'rp-progress-bar',
  standalone: true,
  templateUrl: './progress-bar.component.html',
  styleUrl: './progress-bar.component.scss',
  imports: [MatProgressBarModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressBarComponent {
  value = input.required<number>();
  mode = input<ProgressBarMode>('determinate');
  title = input<string>('');

  readonly progressColor = computed(() => {
    if (this.value() < 50) {
      return ProgressBarColor.Red;
    } else if (this.value() < 100) {
      return ProgressBarColor.Orange;
    } else {
      return ProgressBarColor.Green;
    }
  });
}
